// created from 'create-ts-index'

export * from './one-list-update.model';
export * from './one-list.model';
